import { css } from '@emotion/react'
import { memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import layers from '../styles/layers'
import shape from '../styles/shape'

const linkButtonStyles = css({
    padding: `${getThemeSpacing(0.75)} ${getThemeSpacing(2)}`,
    borderRadius: shape.borderRadius,
    border: '1px solid ' + palette.buttonBorder,
    boxShadow: layers.one,
    cursor: 'pointer',
    textDecoration: 'none',
})

interface LinkButtonProps {
    id?: string
    href?: string
    onClick?: any
    children?: any
    overrides?: any
}

const LinkButton = (props: LinkButtonProps) => {
    const { id, href, onClick, overrides, children } = props
    return (
        <a
            id={id}
            href={href}
            onClick={onClick}
            css={[linkButtonStyles, overrides]}
        >
            {children}
        </a>
    )
}

export default memo(LinkButton)
